// Simple cross-component trigger for the home walkthrough.
// The sidebar schedules a tour; Home consumes it on mount.
// If Home is already mounted, the window event fires instead.

let pending = false;

export const scheduleTour = () => { pending = true; };
export const consumeTour  = () => { const v = pending; pending = false; return v; };
